module.exports = __webpack_public_path__ + "img/m-banner.f0c8884a.jpg";